module.exports = __webpack_public_path__ + "img/chat_group_groupManager01.54dd22fd.png";